import { Checkbox, Select } from './styles'
import { FormItem, Input } from '../styles'
import React from 'react'
import { Col, Row } from 'antd'
import CompensationRequestByChequeInputGroupHook from './CompensationRequestByChequeInputGroup.hook'

function CompensationRequestByChequeInputGroup() {
  const {
    // State
    isCreateOrEditMode,
    selectedProvinceCode,
    selectedDistrictCode,
    selectedSubDistrictCode,
    isRequired,

    // Loading states
    isLoadingPolicyData,
    isProvinceLoading,
    isDistrictLoading,
    isSubDistrictLoading,

    // Options
    provinceOptions,
    districtOptions,
    subDistrictOptions,
    postalOptions,

    // Handlers
    handleProvinceChange,
    handleDistrictChange,
    handleSubDistrictChange,
    handleSetIsUseAddressFromAddressPolicy,
  } = CompensationRequestByChequeInputGroupHook()

  return (
    <>
      <Row gutter={16}>
        <Col className="gutter-row" span={6}>
          <FormItem name="isUserPolicyAddress" valuePropName="checked">
            <Checkbox
              disabled={!isCreateOrEditMode}
              onChange={(e) => handleSetIsUseAddressFromAddressPolicy(e.target.checked)}
            >
              ใช้ข้อมูลที่ระบุไว้ในกรมธรรม์
            </Checkbox>
          </FormItem>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col className="gutter-row" span={6}>
          <FormItem name="compensationPersonName" label="ชื่อผู้รับ *" rules={[isRequired]}>
            <Input placeholder="ระบุ" disabled={!isCreateOrEditMode} />
          </FormItem>
        </Col>
        <Col className="gutter-row" span={6}>
          <FormItem
            name="compensationMobileNumber"
            label="โทรศัพท์มือถือ *"
            rules={[
              { required: true, message: 'กรุณากรอกเบอร์โทรศัพท์' },
              { pattern: /^\d+$/, message: 'กรุณากรอกเป็นตัวเลขเท่านั้น' },
              { min: 10, message: 'กรุณากรอกเบอร์โทรศัพท์อย่างน้อย 10 หลัก' },
            ]}
          >
            <Input
              placeholder="ระบุ"
              disabled={!isCreateOrEditMode}
              inputMode="numeric"
              minLength={10}
              maxLength={10}
            />
          </FormItem>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col className="gutter-row" span={6}>
          <FormItem name="compensationAddress" label="ที่อยู่ *" rules={[isRequired]}>
            <Input placeholder="ระบุ" disabled={!isCreateOrEditMode} />
          </FormItem>
        </Col>
        <Col className="gutter-row" span={6}>
          <FormItem name="province" label="จังหวัด *" rules={[isRequired]}>
            <Select
              showSearch
              placeholder="เลือก"
              options={provinceOptions}
              onChange={handleProvinceChange}
              disabled={!isCreateOrEditMode}
              loading={isProvinceLoading || isLoadingPolicyData}
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
            />
          </FormItem>
        </Col>
        <Col className="gutter-row" span={6}>
          <FormItem name="district" label="เขต/อำเภอ *" rules={[isRequired]}>
            <Select
              showSearch
              placeholder="เลือก"
              options={districtOptions}
              onChange={handleDistrictChange}
              disabled={!selectedProvinceCode || !isCreateOrEditMode}
              loading={isDistrictLoading || isLoadingPolicyData}
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
            />
          </FormItem>
        </Col>
        <Col className="gutter-row" span={6}>
          <FormItem name="subdistrict" label="แขวง/ตำบล *" rules={[isRequired]}>
            <Select
              showSearch
              placeholder="เลือก"
              options={subDistrictOptions}
              onChange={handleSubDistrictChange}
              disabled={!selectedDistrictCode || !isCreateOrEditMode}
              loading={isSubDistrictLoading || isLoadingPolicyData}
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
            />
          </FormItem>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col className="gutter-row" span={6}>
          <FormItem name="postal" label="รหัสไปรษณีย์ *" rules={[isRequired]}>
            <Select
              showSearch
              placeholder="เลือก"
              options={postalOptions}
              disabled={!selectedSubDistrictCode || !isCreateOrEditMode}
              loading={isSubDistrictLoading || isLoadingPolicyData}
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
            />
          </FormItem>
        </Col>
      </Row>
    </>
  )
}

export default CompensationRequestByChequeInputGroup
